import { Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { APP_TITLE } from '@/config/routes';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import './Layout.css';

/**
 * Layout component that provides the main application structure
 * with navigation sidebar, header, and content area.
 * Navigation items come from the route config (config/routes.ts).
 *
 * @example
 * ```tsx
 * // In router configuration
 * <Route element={<Layout />}>
 *   <Route path="/" element={<Dashboard />} />
 *   <Route path="/nodes" element={<Nodes />} />
 * </Route>
 * ```
 */
export function Layout() {
  const { logout } = useAuth();
  const navigate = useNavigate();

  /**
   * Handle user logout from sidebar (logout never rejects)
   */
  const handleLogout = async () => {
    await logout();
    navigate('/login', { replace: true });
  };

  return (
    <div className="layout">
      {/* Sidebar Navigation */}
      <Sidebar title={APP_TITLE} subtitle="Admin Panel" onLogout={handleLogout} />

      {/* Main Content Area */}
      <main className="layout-main">
        {/* Header with page title and user menu */}
        <Header />

        {/* Page Content */}
        <div className="main-content">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
